import { Box } from "@chakra-ui/react";
import React from "react";
import Package from "../components/Package";

const PackageScreen = () => {
  return (
    <Box>
      <Package />
    </Box>
  );
};

export default PackageScreen;
